import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-inkop',
  templateUrl: './inkop.component.html',
})
export class FeaturePreviewInkop extends FeaturePreviewComponent {}
